
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 16A8 8 0 108 0a8 8 0 000 16zm-1.922-4.175c.107.108.24.175.387.175.147 0 .28-.067.4-.175l5.993-6.852a.619.619 0 00-.027-.82.519.519 0 00-.76.027l-5.62 6.41-2.535-2.755a.518.518 0 00-.76 0 .619.619 0 000 .82l2.922 3.17z","fill":"#6C6C6C"}})])
          )
        }
      }
    